// extracted by mini-css-extract-plugin
export default {"BookingUpcomingStage":"styles_BookingUpcomingStage__AjqzP","button":"styles_button__JAKAg","text":"styles_text__aGfXu"};